<span><ng-content /></span>
@if (icon) {
  <palantir-icon [name]="icon" />
}
